<template>
  <MainLayout>
    <b-row>
      <b-col
        class="shadow-sm"
        style
      >
        <u-loader v-if="isLoading" />
        <b-card-body v-else>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />
          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Login
          </h4>
          <div v-if="isUserLoggedIn">
            <h6>Willkommen</h6>
            Sie sind bereits eingeloggt
          </div>
          <div
            v-else
            id="col-12"
          >
            <form @submit.prevent="login">
              <div class="form-group">
                <b-container class="pb-0 pt-0">
                  <b-row>
                    <label
                      for="filter"
                      class="pl-0 col-3 defaultLabel"
                    >Name</label>
                    <div class="col-9 pl-0">
                      <v-flex sm6>
                        <v-text-field
                          id="userNameInput"
                          v-model="userName"
                          type="text"
                          label="Benutzername"
                          placeholder="example@unia.ch"
                        />
                      </v-flex>
                    </div>
                  </b-row>
                </b-container>
              </div>
              <div class="form-group">
                <b-container class="pb-0 pt-0">
                  <b-row>
                    <label
                      for="filter"
                      class="pl-0 col-3 defaultLabel"
                    >Passwort</label>
                    <div class="col-9 pl-0">
                      <v-flex sm6>
                        <v-text-field
                          id="passwordInput"
                          v-model="password"
                          :type="showPassword ? 'text' : 'password'"
                          name="input-10-2"
                          label="Passwort"
                          class="input-group--focused"
                          :append-icon="
                            showPassword ? 'visibility' : 'visibility_off'
                          "
                          @click:append="showPassword = !showPassword"
                        />
                      </v-flex>
                    </div>
                  </b-row>
                </b-container>
              </div>
              <b-btn
                variant="success"
                type="submit"
              >
                Login
              </b-btn>
            </form>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import { Login, IsUserLoggedIn } from "@/services/user.service.js";

export default {
  components: {
    MainLayout,
  },
  data() {
    return {
      userName: "",
      password: "",
      isUserLoggedIn: false,
      errorObject: null,
      showPassword: false,
      isLoading: false,
    };
  },
  mounted() {
    this.isUserLoggedIn = IsUserLoggedIn();
  },
  methods: {
    login() {
      this.errorObject = null;
      this.isLoading = true;

      // if login was succesful, redirect to previous page
      Login(
        this.userName,
        this.password,
        () => {
          this.isUserLoggedIn = true;
          this.isLoading = false;
          const urlParams = new URLSearchParams(window.location.search);
          const urlSource = urlParams.get("source");

          if (urlSource) {
            this.$router.push({
              path: urlSource,
              quey: { source: this.$route.path },
            });
          } else {
            this.$router.push({
              path: "/",
              quey: { source: this.$route.path },
            });
          }
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.v-treeview > .v-treeview-node--leaf {
  margin-left: 21px !important;
}
.v-icon.v-icon.v-icon--link {
  margin-left: 6px !important;
}
.formValidationError {
  color: red;
}
</style>
